import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { withRouter } from "../comps/withRouter";
import { FiArrowRight } from "react-icons/fi";
import Hamburger from "../comps/Hamburger";
import Footer from "../comps/Footer";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Signup from "../comps/Signup.js";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Search from '../static/search.svg'
import Cart from '../static/cart.svg'
import Location from '../static/location.svg'
import Group from '../static/group.webp'
import Fade from 'react-reveal/Fade';
import John from '../static/john.webp'
import Angie from '../static/angie.webp'
import Cac from '../static/cac.webp'
import BizGif from '../static/bizAnimation.gif'
import BlueOcean from '../static/blueocean.webp'
import Drawing from '../static/drawing.svg'

class LandingPage extends React.Component {
  constructor() {
    super();
    this.state = {
      currentZipcode: "",
      arrowOpacity: 1,
      arrowTransitions: "",
      searchedMarketInfo: {},
      location: "",
      autoComplete: "",
    };
  }

  componentDidMount() {
    this.handleOnSelect = (item) => {
      this.setState({
        currentZipcode: item.city
      });
    }
    if(localStorage.getItem("location") !== ""){
      var location = localStorage.getItem("location")
      console.log("NOT NEW USER - USING "+location)
      this.setState({
        location: location
      })
      var endpoint = process.env.REACT_APP_API_ENDPOINT.concat(
        "",
        "api/markets/",
        location
      );
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };
      fetch(endpoint, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          this.setState({
              allMarkets: result,
          });
            if (result.length >= 1) {
              this.props.dispatch({
                type: "MARKETS",
                payload: {
                  displayedMarkets: result,
                  displayedLocation: this.state.location,
                },
              });
              this.props.router.navigate(
                "/marketplace?" + this.state.location
              );
          } else {
            console.log(`Warning: didn't get any results back`);
          }
        })
        .catch((error) => console.log("error", error));
    }
    else{
      console.log("New user - Using landing page")
    }
  }

    handleOnFocus = () => {
    var endpoint = process.env.REACT_APP_API_ENDPOINT.concat(
      "",
      "api/markets"
    );
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
      fetch(endpoint, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        this.setState({
            autoComplete: result,
        });
        console.log("Found results for search")
        if(result.length === 0){
          toast("Error with api")
        }
      })
      .catch((error) => console.log("error", error));
    };

    notify = () => {
      toast("Unsupported zipcode or city");
    };
    empty = () => {
      toast("Please enter a zipcode or city");
    };

    handleZipCodeClick = e => {

      console.log(`react environment is: ${process.env.REACT_APP_ENVIRONMENT}`)
      if(process.env.REACT_APP_ENVIRONMENT == 'noDocker')
      {
          var currentZipcodeLocal = "San Francisco"
          var displayedMarketsLocal = [
              {
                "address": "290 Noe St", 
                "city": "San Francisco", 
                "marketid": 7, 
                "name": "CASTRO FARMERS' MARKET", 
                "zipcode": 94114
              }, 
              {
                "address": "1377 Fell St", 
                "city": "San Francisco", 
                "marketid": 12, 
                "name": "DIVISADERO FARMERS' MARKET", 
                "zipcode": 94117
              }, 
              {
                "address": "1700 O'Farrell St", 
                "city": "San Francisco", 
                "marketid": 19, 
                "name": "FILLMORE FARMERS' MARKET", 
                "zipcode": 94115
              }, 
              {
                "address": "1315 8th Ave", 
                "city": "San Francisco", 
                "marketid": 20, 
                "name": "INNER SUNSET FARMERS' MARKET", 
                "zipcode": 94122
              }, 
              {
                "address": "1 Warriors Way", 
                "city": "San Francisco", 
                "marketid": 33, 
                "name": "THRIVE CITY FARMERS' MARKET", 
                "zipcode": 94158
              }, 
              {
                "address": "505 Parnassus Ave", 
                "city": "San Francisco", 
                "marketid": 34, 
                "name": "UCSF PARNASSUS FARMERS' MARKET", 
                "zipcode": 94143
              }
            ]
          

          this.props.dispatch({
              type: 'MARKETS',
              payload: { displayedMarkets: displayedMarketsLocal, displayedLocation: currentZipcodeLocal }
          })
          this.props.router.navigate('/marketplace')
      }
      console.log(`URL to reach is ${process.env.REACT_APP_API_ENDPOINT}`)

      var endpoint = process.env.REACT_APP_API_ENDPOINT.concat('','api/markets/',this.state.currentZipcode)
      console.log(`URL endpoint is ${endpoint}`)

      var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
      
      var searchedMarket = []
      fetch(endpoint, requestOptions)
      .then(response => response.json())
      .then((result) => {
          console.log(`Result length: ${result.length} and results: ${result}`)

          if(result.length >= 1) {
              this.props.dispatch({
                  type: 'MARKETS',
                  payload: { displayedMarkets: result, displayedLocation: this.state.currentZipcode }
              })
              this.props.router.navigate('/marketplace', {marketInfo: result})
          }
          else{
              this.notify()
              console.log(`Warning: didn't get any results back`)
          }
              
      } )
      .catch(error => console.log('error', error));
      

      if(searchedMarket.length < 1)
      {
          console.log(`No markets are available for searched area: ${this.state.currentZipcode} with return: ${searchedMarket}`)
          return
      }
    }

  render() {
    const formatResult = (autoComplete) => {
      return (
        <div>
          <span style={{ display: 'block', textAlign: 'left' }} className="cursor-pointer text-xs text-[#929292] ">Location</span>
          <span style={{ display: 'block', textAlign: 'left' }} className="cursor-pointer  text-base">{autoComplete.city}, {autoComplete.zipcode}</span>
        </div>
      )
    }
  
    return (
      <div>
        <Toaster
          toastOptions={{
            error: {
              iconTheme: {
                primary: "#F06747",
                secondary: "white",
              },
            },
          }}
        />

        <div className="bg-[#144444] pl-36 pr-36 pb-56 md:pl-4 md:pr-4">
        <Fade>
         <div className="flex">
            <div className="w-1/4 md:w-1/2">
              <h1 className="text-3xl text-[#ffffff] pt-8 md:text-2xl" id="title">Berri<span className="text-[#088C61] font-bold">Basket</span></h1>
            </div>
            <div className="w-2/4 md:hidden">
                <Hamburger color={" text-[#ffffff] mr-16 hover:underline underline-offset-4"} bizbtn={" text-[#ffffff] flex items-center z-[999]"} modal={"w-[30vw] bg-[#ffffff] border rounded-lg absolute mt-10 p-6 z-30"}/>
            </div>
            <div className="w-1/2 hidden justify-end mt-8 md:flex">
              <div>
                <Hamburger/>
              </div>
            </div>
            <div className="w-1/4 flex justify-end md:hidden">
            <Signup signOut={"text-white bg-[#088C61] rounded-lg m-8 w-24 h-12 mt-6 mr-0"}/>
            </div>
          </div>
          </Fade>
      <Fade bottom>
          <div className="flex justify-center mt-32">
            <h1 className="text-center text-6xl text-[#ffffff] w-1/2 md:w-full md:text-3xl" id="title">Discover farm-fresh local produce near you</h1>
            <img className="absolute w-[16rem] ml-[25.25rem] -z-1 mt-[6.75rem] rotate-[4deg] hidden" src = {Drawing}></img>
          </div>

          <div className="flex justify-center">
            <div className="w-1/2 mt-8 md:w-full">
                <ReactSearchAutocomplete
                // items={this.state.autoComplete}
                  autoFocus
                //  formatResult={formatResult}
                 // fuseOptions={{ keys: ["city", "zipcode", "marketid"] }}
                 // resultStringKeyName="city"
                 // onSelect={this.handleOnSelect}
                  // onFocus={this.handleOnFocus}
                  // showClear={false}
                  styling={
                    {
                      backgroundColor: "white",
                      fontFamily: "Poppins",
                      height: "44px",
                      boxShadow: "",
                    }
                    }
                  placeholder="Search by markets - coming soon"
                  maxResults={6}
                />
                <div className="flex justify-end">
                  <button type="button" className="text-white bg-[#088C61] font-medium rounded-full relative p-2 -top-10 mr-2"><FiArrowRight /></button>
                </div>
                  <Link to={'/zipcodes'}><h3 className="text-[#929292] -mt-4 text-sm ml-2">View all supported zipcodes</h3></Link> 
              </div>
          </div>
      </Fade>
        </div>

        <Fade bottom>
        <div className="pl-36 pr-36 md:pl-4 md:pr-4">
          <h1 className="text-3xl mt-16 w-1/4 md:w-full md:text-2xl" id="title">How BerriBasket works</h1>
            <div className="flex md:block">
              <div className="w-1/3 rounded-lg p-10 m-10 md:w-full md:m-0 md:mt-4">
                <div className="flex justify-center">
                  <img alt="cart" className="h-20 mb-2" src = {Location}></img>
                </div>
                <h3 className="text-xl text-center mt-6" id="title">Search for markets</h3>
                <h3 className="text-center text-[#929292] mt-4">Enter your zipcode to discover nearby farmer's markets</h3>
              </div>

              <div className="w-1/3 rounded-lg p-10 m-10 md:w-full md:m-0 md:mt-0">
                <div className="flex justify-center">
                  <img alt="cart" className="h-20 mb-2" src = {Search}></img>
                </div>
                <h3 className="text-xl text-center mt-6" id="title">Shop markets</h3>
                <h3 className="text-center text-[#929292] mt-4">Browse the items from local vendors at farmers markets</h3>
              </div>

              <div className="w-1/3 rounded-lg p-10 m-10 md:w-full md:m-0 md:mt-0">
                <div className="flex justify-center">
                  <img alt="cart" className="h-20 mb-2" src = {Cart}></img>
                </div>
                <h3 className="text-xl text-center mt-6" id="title">Purchase fresh produce</h3>
                <h3 className="text-center text-[#929292] mt-4">Pre-order these items for pickup. Delivery coming soon</h3>
              </div>
            </div>
        </div>
        </Fade>

<Fade>
  <div className="mb-0 mt-6 bg-[#fbfbfb] border p-12 md:p-8">
        <h2 className="text-5xl font-bold text-center md:text-4xl md:mt-6" id="title">Our misson</h2>
        <h3 className="text-[#929292]  text-center mt-2">BerriBasket's mission and drive to create a product for farmers</h3>
    <div className="flex justify-center">
      <div className="w-3/4 md:w-full">

        <div className="w-full m-12 mt-16 flex items-center md:flex-wrap md:m-0 md:mt-0">
        <div className="w-full hidden md:flex mt-12">
            <img alt="BerriBasket at a farm in Palo Alto, CA" className="rounded-lg w-full object-cover h-96 md:h-44 hover:scale-105 ease-in-out duration-300" src = {John}></img>
        </div>
          <div className="w-1/2 md:w-full">
          <h2 className="text-3xl font-bold mt-4 md:mt-6" id="title">Empowering farmers</h2>
          <div className="flex mt-4">
            <div>
                <svg width="34" height="34" viewBox="0 0 75 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_8)">
                <path d="M40.6769 50.9421L42.9665 64.894C43.1324 64.7807 43.2822 64.6463 43.4117 64.4942C47.4515 57.5676 53.6243 53.3392 61.1877 50.8607C62.2035 50.5276 63.2075 50.1585 64.2199 49.8136C66.1251 49.168 67.5389 49.8022 68.2593 51.6909C68.9842 53.6727 69.2692 55.7867 69.0947 57.8908C68.7019 64.1372 65.5962 69.0432 61.0797 73.1986C57.6913 76.373 53.6869 78.8422 49.3082 80.4568C48.1951 80.8592 47.0151 81.0811 45.6377 81.4459C45.8226 82.3727 45.9367 83.3126 45.9793 84.2573C45.9515 85.5409 45.8103 86.8205 45.5573 88.0814C45.4796 88.4846 45.2636 88.8505 44.9454 89.1177C44.6271 89.385 44.2259 89.5373 43.8086 89.5493C43.3631 89.6027 42.9134 89.5014 42.5377 89.263C42.1619 89.0243 41.8836 88.6638 41.7511 88.2438C41.2981 87.1002 40.9546 85.9119 40.6177 84.7276C40.4801 84.1257 40.3762 83.5167 40.3064 82.9033C38.56 82.9481 36.9913 83.1114 35.4418 83.0075C25.4185 82.3356 17.2188 78.2985 11.2798 70.2282C10.5789 69.2828 10.0062 68.2512 9.57592 67.1599C8.69265 64.8745 9.48685 62.7086 11.7655 61.7237C18.7051 58.7233 25.8354 57.9762 33.0742 60.4798C34.5877 61.0032 35.9403 61.9691 37.5812 62.846C37.4707 59.1781 36.9187 55.5874 36.6029 51.9055C34.3709 52.0154 32.3084 52.248 30.2545 52.1968C21.2702 51.9735 14.5378 48.1293 10.9046 39.9189C8.28524 34.0005 8.462 27.8678 10.7295 21.8218C11.9381 18.5492 13.7531 15.522 16.0821 12.8937C18.7404 9.90914 22.2367 8.23133 25.8387 6.71092C31.0908 4.49369 36.5804 4.04594 42.1403 4.85437C46.5636 5.47222 50.5469 7.78964 53.2168 11.2988C57.4459 16.6852 59.8733 22.7817 59.5764 29.6607C59.1828 38.7785 54.3416 45.0546 46.0159 48.856C44.3139 49.6372 42.5217 50.2284 40.6769 50.9421ZM28.0522 9.74691C22.7895 10.5333 20.4324 11.8633 17.5196 16.2006C14.0593 21.3512 12.4438 27.002 13.3702 33.1451C14.458 40.3581 19.1746 47.101 28.8011 47.8083C34.9369 48.26 41.0776 46.8559 46.3993 43.7848C52.1845 40.5277 55.0555 35.4923 55.009 28.904C54.9728 23.7493 52.9688 19.287 50.0416 15.185C47.4243 11.5149 43.6625 9.59863 39.1595 9.43909C35.4671 9.30807 31.7552 9.62711 28.0522 9.74691ZM39.7153 78.1326C39.3409 75.8516 38.9813 73.5487 38.5666 71.256C38.4607 70.9074 38.2534 70.5979 37.97 70.3649C36.7473 69.2172 35.4776 68.1175 34.2604 66.9642C32.4298 65.2558 30.0996 64.1536 27.5938 63.8114C23.5516 63.1612 19.408 63.3951 15.4578 64.4965C14.9924 64.6549 14.5379 64.843 14.0974 65.0604C18.9666 74.9 32.1996 79.8147 39.7153 78.1326ZM64.0924 54.3118C63.7085 54.3279 63.3267 54.3729 62.9496 54.4466C59.3167 55.546 55.8555 56.9946 52.8716 59.3839C49.5997 62.004 46.8367 65.0171 45.3288 68.9686C44.3406 71.4036 44.1672 74.0804 44.8339 76.6098C45.3886 76.5557 45.9388 76.4622 46.4801 76.3294C53.6145 73.9333 59.2388 69.6568 62.8334 63.0941C64.3407 60.4131 64.7893 57.2849 64.0924 54.3118Z" fill="#CBE78F"/>
                <path d="M38.4224 40.2532C38.4602 41.1477 38.5371 42.0051 38.5236 42.8615C38.5022 44.1705 37.953 44.9415 37.0024 45.1199C36.0721 45.2945 35.245 44.7742 34.7283 43.581C34.3636 42.7391 34.1009 41.8525 33.7952 40.9943C32.3377 40.7535 30.9225 40.5425 29.516 40.273C29.0276 40.1573 28.5549 39.9862 28.1073 39.7632C27.2089 39.3612 26.7211 38.6599 26.9265 37.6859C27.1444 36.6535 28.0572 36.6176 28.8797 36.6482C30.2564 36.6992 31.6292 36.8317 33.3045 36.9517L32.5198 30.0941C31.5519 29.9599 30.746 29.8694 29.9487 29.7318C25.8253 29.0202 24.7888 25.9852 25.878 22.7226C26.5437 20.7291 27.6025 19.5458 30.5833 17.3644C30.4364 16.665 30.2684 15.9003 30.1157 15.1335C29.9658 14.3888 30.1436 13.6098 30.908 13.484C31.2305 13.4637 31.5534 13.5104 31.8554 13.6212C32.1575 13.7319 32.4319 13.9042 32.6609 14.1268C33.1931 14.6845 33.4378 15.507 33.8067 16.2157C35.1862 16.5387 36.5854 16.7974 37.9317 17.2185C38.1798 17.3155 38.4051 17.4606 38.5943 17.6454C38.7836 17.8301 38.9324 18.0507 39.0328 18.2938C39.2744 18.9728 38.7723 19.4757 38.1149 19.6898C37.0528 20.0389 35.9725 20.3272 34.8331 20.6603C34.8481 20.9605 34.8378 21.1984 34.8749 21.4286C35.1579 23.192 35.4501 24.9539 35.7413 26.7284C36.4061 26.8439 36.8229 26.9304 37.2444 26.9861C37.9894 27.0855 38.7426 27.137 39.4835 27.259C44.6304 28.1062 45.1772 31.6223 43.7361 35.169C42.9859 37.0137 41.59 38.353 39.9051 39.4086C39.4337 39.7061 38.9366 39.9625 38.4224 40.2532ZM36.5803 30.0427L37.5993 36.252C39.2159 35.4456 40.3432 34.4592 40.8328 32.8953C41.246 31.5755 40.9023 30.8499 39.5957 30.505C38.6004 30.2968 37.5938 30.1428 36.5805 30.0438L36.5803 30.0427ZM31.2543 21.9853C29.3864 23.0857 28.477 24.3154 28.8683 25.3739C29.3805 26.758 30.6719 26.5875 32.0277 26.6976L31.2543 21.9853Z" fill="#CBE78F"/>
                </g>
                <defs>
                <clipPath id="clip0_1_8">
                <rect width="61.1223" height="86.0278" fill="white" transform="translate(0 9.89838) rotate(-9.31973)"/>
                </clipPath>
                </defs>
                </svg>
            </div>
            <div>
              <h3 className="text-[#929292]  ml-2.5">Small farms are responsible for ~80% of the food produced in the world but around 30% of these farming families live below the poverty line. Farmers provide fresh produce, but face challenges directly reaching consumers without relying on in-person farmers markets</h3>
            </div>
          </div>
          </div>
          <div className="w-1/2 m-20 mt-0 mb-0 md:hidden">
            <img className="rounded-lg w-full object-cover h-96 md:h-44 hover:scale-105 ease-in-out duration-300" alt="BerriBasket at a farm in Palo Alto, CA" src = {John}></img>
          </div>
        </div>  

        <div className="w-full m-12 mt-16 flex items-center md:flex-wrap md:m-0 md:mt-16">
        <div className="w-1/2 m-20 ml-0 mt-0 mb-0 md:w-full md:m-0 md:mt-12">
            <img className="rounded-lg w-full object-cover h-80 md:h-44 hover:scale-105 ease-in-out duration-300 " alt="BerriBasket talking with Angie, a farmers market manager" src = {Angie}></img>
        </div>
          <div className="w-1/2 md:w-full">
          <h2 className="text-3xl font-bold mt-4 md:mt-6" id="title">A tech filled world</h2>
          <div className="flex mt-4">
            <div>
                <svg width="34" height="34" viewBox="0 0 75 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_8)">
                <path d="M40.6769 50.9421L42.9665 64.894C43.1324 64.7807 43.2822 64.6463 43.4117 64.4942C47.4515 57.5676 53.6243 53.3392 61.1877 50.8607C62.2035 50.5276 63.2075 50.1585 64.2199 49.8136C66.1251 49.168 67.5389 49.8022 68.2593 51.6909C68.9842 53.6727 69.2692 55.7867 69.0947 57.8908C68.7019 64.1372 65.5962 69.0432 61.0797 73.1986C57.6913 76.373 53.6869 78.8422 49.3082 80.4568C48.1951 80.8592 47.0151 81.0811 45.6377 81.4459C45.8226 82.3727 45.9367 83.3126 45.9793 84.2573C45.9515 85.5409 45.8103 86.8205 45.5573 88.0814C45.4796 88.4846 45.2636 88.8505 44.9454 89.1177C44.6271 89.385 44.2259 89.5373 43.8086 89.5493C43.3631 89.6027 42.9134 89.5014 42.5377 89.263C42.1619 89.0243 41.8836 88.6638 41.7511 88.2438C41.2981 87.1002 40.9546 85.9119 40.6177 84.7276C40.4801 84.1257 40.3762 83.5167 40.3064 82.9033C38.56 82.9481 36.9913 83.1114 35.4418 83.0075C25.4185 82.3356 17.2188 78.2985 11.2798 70.2282C10.5789 69.2828 10.0062 68.2512 9.57592 67.1599C8.69265 64.8745 9.48685 62.7086 11.7655 61.7237C18.7051 58.7233 25.8354 57.9762 33.0742 60.4798C34.5877 61.0032 35.9403 61.9691 37.5812 62.846C37.4707 59.1781 36.9187 55.5874 36.6029 51.9055C34.3709 52.0154 32.3084 52.248 30.2545 52.1968C21.2702 51.9735 14.5378 48.1293 10.9046 39.9189C8.28524 34.0005 8.462 27.8678 10.7295 21.8218C11.9381 18.5492 13.7531 15.522 16.0821 12.8937C18.7404 9.90914 22.2367 8.23133 25.8387 6.71092C31.0908 4.49369 36.5804 4.04594 42.1403 4.85437C46.5636 5.47222 50.5469 7.78964 53.2168 11.2988C57.4459 16.6852 59.8733 22.7817 59.5764 29.6607C59.1828 38.7785 54.3416 45.0546 46.0159 48.856C44.3139 49.6372 42.5217 50.2284 40.6769 50.9421ZM28.0522 9.74691C22.7895 10.5333 20.4324 11.8633 17.5196 16.2006C14.0593 21.3512 12.4438 27.002 13.3702 33.1451C14.458 40.3581 19.1746 47.101 28.8011 47.8083C34.9369 48.26 41.0776 46.8559 46.3993 43.7848C52.1845 40.5277 55.0555 35.4923 55.009 28.904C54.9728 23.7493 52.9688 19.287 50.0416 15.185C47.4243 11.5149 43.6625 9.59863 39.1595 9.43909C35.4671 9.30807 31.7552 9.62711 28.0522 9.74691ZM39.7153 78.1326C39.3409 75.8516 38.9813 73.5487 38.5666 71.256C38.4607 70.9074 38.2534 70.5979 37.97 70.3649C36.7473 69.2172 35.4776 68.1175 34.2604 66.9642C32.4298 65.2558 30.0996 64.1536 27.5938 63.8114C23.5516 63.1612 19.408 63.3951 15.4578 64.4965C14.9924 64.6549 14.5379 64.843 14.0974 65.0604C18.9666 74.9 32.1996 79.8147 39.7153 78.1326ZM64.0924 54.3118C63.7085 54.3279 63.3267 54.3729 62.9496 54.4466C59.3167 55.546 55.8555 56.9946 52.8716 59.3839C49.5997 62.004 46.8367 65.0171 45.3288 68.9686C44.3406 71.4036 44.1672 74.0804 44.8339 76.6098C45.3886 76.5557 45.9388 76.4622 46.4801 76.3294C53.6145 73.9333 59.2388 69.6568 62.8334 63.0941C64.3407 60.4131 64.7893 57.2849 64.0924 54.3118Z" fill="#CBE78F"/>
                <path d="M38.4224 40.2532C38.4602 41.1477 38.5371 42.0051 38.5236 42.8615C38.5022 44.1705 37.953 44.9415 37.0024 45.1199C36.0721 45.2945 35.245 44.7742 34.7283 43.581C34.3636 42.7391 34.1009 41.8525 33.7952 40.9943C32.3377 40.7535 30.9225 40.5425 29.516 40.273C29.0276 40.1573 28.5549 39.9862 28.1073 39.7632C27.2089 39.3612 26.7211 38.6599 26.9265 37.6859C27.1444 36.6535 28.0572 36.6176 28.8797 36.6482C30.2564 36.6992 31.6292 36.8317 33.3045 36.9517L32.5198 30.0941C31.5519 29.9599 30.746 29.8694 29.9487 29.7318C25.8253 29.0202 24.7888 25.9852 25.878 22.7226C26.5437 20.7291 27.6025 19.5458 30.5833 17.3644C30.4364 16.665 30.2684 15.9003 30.1157 15.1335C29.9658 14.3888 30.1436 13.6098 30.908 13.484C31.2305 13.4637 31.5534 13.5104 31.8554 13.6212C32.1575 13.7319 32.4319 13.9042 32.6609 14.1268C33.1931 14.6845 33.4378 15.507 33.8067 16.2157C35.1862 16.5387 36.5854 16.7974 37.9317 17.2185C38.1798 17.3155 38.4051 17.4606 38.5943 17.6454C38.7836 17.8301 38.9324 18.0507 39.0328 18.2938C39.2744 18.9728 38.7723 19.4757 38.1149 19.6898C37.0528 20.0389 35.9725 20.3272 34.8331 20.6603C34.8481 20.9605 34.8378 21.1984 34.8749 21.4286C35.1579 23.192 35.4501 24.9539 35.7413 26.7284C36.4061 26.8439 36.8229 26.9304 37.2444 26.9861C37.9894 27.0855 38.7426 27.137 39.4835 27.259C44.6304 28.1062 45.1772 31.6223 43.7361 35.169C42.9859 37.0137 41.59 38.353 39.9051 39.4086C39.4337 39.7061 38.9366 39.9625 38.4224 40.2532ZM36.5803 30.0427L37.5993 36.252C39.2159 35.4456 40.3432 34.4592 40.8328 32.8953C41.246 31.5755 40.9023 30.8499 39.5957 30.505C38.6004 30.2968 37.5938 30.1428 36.5805 30.0438L36.5803 30.0427ZM31.2543 21.9853C29.3864 23.0857 28.477 24.3154 28.8683 25.3739C29.3805 26.758 30.6719 26.5875 32.0277 26.6976L31.2543 21.9853Z" fill="#CBE78F"/>
                </g>
                <defs>
                <clipPath id="clip0_1_8">
                <rect width="61.1223" height="86.0278" fill="white" transform="translate(0 9.89838) rotate(-9.31973)"/>
                </clipPath>
                </defs>
                </svg>
            </div>
            <div>
              <h3 className="text-[#929292]  ml-2.5">BerriBasket, allows customers to purchase products online, and an app for the farmers market and vendors to manage their online store and accept orders</h3>
            </div>
          </div>
          </div>
        </div>  

        <div className="w-full m-12 mt-16 flex items-center md:flex-wrap md:m-0 md:mt-16">
        <div className="w-full hidden md:flex mt-6">
          <img alt="BerriBasket Business" className="rounded-lg w-full object-cover h-72 md:h-48" src = {BizGif}></img>
        <div/>
        </div>
          <div className="w-1/2 md:w-full">
          <h2 className="text-3xl font-bold mt-4 md:mt-6" id="title">Product management</h2>
          <div className="flex mt-4">
            <div>
                <svg width="34" height="34" viewBox="0 0 75 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_8)">
                <path d="M40.6769 50.9421L42.9665 64.894C43.1324 64.7807 43.2822 64.6463 43.4117 64.4942C47.4515 57.5676 53.6243 53.3392 61.1877 50.8607C62.2035 50.5276 63.2075 50.1585 64.2199 49.8136C66.1251 49.168 67.5389 49.8022 68.2593 51.6909C68.9842 53.6727 69.2692 55.7867 69.0947 57.8908C68.7019 64.1372 65.5962 69.0432 61.0797 73.1986C57.6913 76.373 53.6869 78.8422 49.3082 80.4568C48.1951 80.8592 47.0151 81.0811 45.6377 81.4459C45.8226 82.3727 45.9367 83.3126 45.9793 84.2573C45.9515 85.5409 45.8103 86.8205 45.5573 88.0814C45.4796 88.4846 45.2636 88.8505 44.9454 89.1177C44.6271 89.385 44.2259 89.5373 43.8086 89.5493C43.3631 89.6027 42.9134 89.5014 42.5377 89.263C42.1619 89.0243 41.8836 88.6638 41.7511 88.2438C41.2981 87.1002 40.9546 85.9119 40.6177 84.7276C40.4801 84.1257 40.3762 83.5167 40.3064 82.9033C38.56 82.9481 36.9913 83.1114 35.4418 83.0075C25.4185 82.3356 17.2188 78.2985 11.2798 70.2282C10.5789 69.2828 10.0062 68.2512 9.57592 67.1599C8.69265 64.8745 9.48685 62.7086 11.7655 61.7237C18.7051 58.7233 25.8354 57.9762 33.0742 60.4798C34.5877 61.0032 35.9403 61.9691 37.5812 62.846C37.4707 59.1781 36.9187 55.5874 36.6029 51.9055C34.3709 52.0154 32.3084 52.248 30.2545 52.1968C21.2702 51.9735 14.5378 48.1293 10.9046 39.9189C8.28524 34.0005 8.462 27.8678 10.7295 21.8218C11.9381 18.5492 13.7531 15.522 16.0821 12.8937C18.7404 9.90914 22.2367 8.23133 25.8387 6.71092C31.0908 4.49369 36.5804 4.04594 42.1403 4.85437C46.5636 5.47222 50.5469 7.78964 53.2168 11.2988C57.4459 16.6852 59.8733 22.7817 59.5764 29.6607C59.1828 38.7785 54.3416 45.0546 46.0159 48.856C44.3139 49.6372 42.5217 50.2284 40.6769 50.9421ZM28.0522 9.74691C22.7895 10.5333 20.4324 11.8633 17.5196 16.2006C14.0593 21.3512 12.4438 27.002 13.3702 33.1451C14.458 40.3581 19.1746 47.101 28.8011 47.8083C34.9369 48.26 41.0776 46.8559 46.3993 43.7848C52.1845 40.5277 55.0555 35.4923 55.009 28.904C54.9728 23.7493 52.9688 19.287 50.0416 15.185C47.4243 11.5149 43.6625 9.59863 39.1595 9.43909C35.4671 9.30807 31.7552 9.62711 28.0522 9.74691ZM39.7153 78.1326C39.3409 75.8516 38.9813 73.5487 38.5666 71.256C38.4607 70.9074 38.2534 70.5979 37.97 70.3649C36.7473 69.2172 35.4776 68.1175 34.2604 66.9642C32.4298 65.2558 30.0996 64.1536 27.5938 63.8114C23.5516 63.1612 19.408 63.3951 15.4578 64.4965C14.9924 64.6549 14.5379 64.843 14.0974 65.0604C18.9666 74.9 32.1996 79.8147 39.7153 78.1326ZM64.0924 54.3118C63.7085 54.3279 63.3267 54.3729 62.9496 54.4466C59.3167 55.546 55.8555 56.9946 52.8716 59.3839C49.5997 62.004 46.8367 65.0171 45.3288 68.9686C44.3406 71.4036 44.1672 74.0804 44.8339 76.6098C45.3886 76.5557 45.9388 76.4622 46.4801 76.3294C53.6145 73.9333 59.2388 69.6568 62.8334 63.0941C64.3407 60.4131 64.7893 57.2849 64.0924 54.3118Z" fill="#CBE78F"/>
                <path d="M38.4224 40.2532C38.4602 41.1477 38.5371 42.0051 38.5236 42.8615C38.5022 44.1705 37.953 44.9415 37.0024 45.1199C36.0721 45.2945 35.245 44.7742 34.7283 43.581C34.3636 42.7391 34.1009 41.8525 33.7952 40.9943C32.3377 40.7535 30.9225 40.5425 29.516 40.273C29.0276 40.1573 28.5549 39.9862 28.1073 39.7632C27.2089 39.3612 26.7211 38.6599 26.9265 37.6859C27.1444 36.6535 28.0572 36.6176 28.8797 36.6482C30.2564 36.6992 31.6292 36.8317 33.3045 36.9517L32.5198 30.0941C31.5519 29.9599 30.746 29.8694 29.9487 29.7318C25.8253 29.0202 24.7888 25.9852 25.878 22.7226C26.5437 20.7291 27.6025 19.5458 30.5833 17.3644C30.4364 16.665 30.2684 15.9003 30.1157 15.1335C29.9658 14.3888 30.1436 13.6098 30.908 13.484C31.2305 13.4637 31.5534 13.5104 31.8554 13.6212C32.1575 13.7319 32.4319 13.9042 32.6609 14.1268C33.1931 14.6845 33.4378 15.507 33.8067 16.2157C35.1862 16.5387 36.5854 16.7974 37.9317 17.2185C38.1798 17.3155 38.4051 17.4606 38.5943 17.6454C38.7836 17.8301 38.9324 18.0507 39.0328 18.2938C39.2744 18.9728 38.7723 19.4757 38.1149 19.6898C37.0528 20.0389 35.9725 20.3272 34.8331 20.6603C34.8481 20.9605 34.8378 21.1984 34.8749 21.4286C35.1579 23.192 35.4501 24.9539 35.7413 26.7284C36.4061 26.8439 36.8229 26.9304 37.2444 26.9861C37.9894 27.0855 38.7426 27.137 39.4835 27.259C44.6304 28.1062 45.1772 31.6223 43.7361 35.169C42.9859 37.0137 41.59 38.353 39.9051 39.4086C39.4337 39.7061 38.9366 39.9625 38.4224 40.2532ZM36.5803 30.0427L37.5993 36.252C39.2159 35.4456 40.3432 34.4592 40.8328 32.8953C41.246 31.5755 40.9023 30.8499 39.5957 30.505C38.6004 30.2968 37.5938 30.1428 36.5805 30.0438L36.5803 30.0427ZM31.2543 21.9853C29.3864 23.0857 28.477 24.3154 28.8683 25.3739C29.3805 26.758 30.6719 26.5875 32.0277 26.6976L31.2543 21.9853Z" fill="#CBE78F"/>
                </g>
                <defs>
                <clipPath id="clip0_1_8">
                <rect width="61.1223" height="86.0278" fill="white" transform="translate(0 9.89838) rotate(-9.31973)"/>
                </clipPath>
                </defs>
                </svg>
            </div>
            <div>
              <h3 className="text-[#929292]  ml-2.5">Our business site allows farmers to manage their storefront by adding the items they would like to sell, manage the prices and quantity of these items at each market they attend, and view the open orders that have been purchased through the customer facing site</h3>
              <button className="text-[#088C61]  mt-6 flex">Coming soon<span className="ml-2 mt-[4px] text-lg"><FiArrowRight/></span></button>
            </div>
          </div>
          </div>
          <div className="w-1/2 m-20 mt-0 mb-0 md:hidden">
              <img alt="BerriBasket Business" className="rounded-lg w-full object-cover h-72 hover:scale-105 ease-in-out duration-300" src = {BizGif}></img>
          </div>
        </div>  
        </div>
      </div>
    </div>
</Fade>


<Fade>
  <div className="ml-36 mr-36 md:ml-4 md:mr-4 mt-32 mb-32 md:mt-20 md:mb-20">
    <h2 className="text-3xl font-bold" id="title">News</h2>
    <div className="flex mt-10 md:block md:mr-0">
      <div className="w-1/3 mr-16 md:w-full">
        <img src = {Group} className="rounded-lg object-cover w-full h-56 hover:scale-105 ease-in-out duration-300" alt="BerriBasket at a farmers market"></img>
        <h2 className="text-xl font-semibold md:text-xl mt-6">BerriBasket vistis local markets in CA</h2>
        <h3 className="text-[#929292] mt-2">The berribasket team has been visting their local farmers and farmers market getting customer feedback and how we can impore our product</h3>
        <a href="https://acf4all.medium.com/berribasket-teams-first-expedition-5da6f116fec9"><button className="text-[#088C61]  mt-6 flex">Read blog<span className="ml-2 mt-[4px] text-lg"><FiArrowRight/></span></button></a>
      </div>
      <div className="w-1/3 mr-16 md:w-full md:mr-0 md:mt-10">
        <img src = {BlueOcean} className="rounded-lg object-cover w-full h-56 hover:scale-105 ease-in-out duration-300" alt="Blue Ocean Challenge Top #100"></img>
        <h2 className="text-xl font-semibold md:text-xl mt-6">Blue Ocean Challenge Top 30</h2>
        <h3 className="text-[#929292] mt-2">BerriBasket is proud to be selected as one of the top 30 pitches in the 2022-2023 Blue Ocean Entrepreneur Competition. Out of over 5000 participants, this achievement reflects our commitment to innovation in the agriculture industry and lasting dedication to our project</h3>
        <a href="https://www.youtube.com/watch?v=LWIOPzZq4e0"><button className="text-[#088C61]  mt-6 flex">View BerriBasket's pitch<span className="ml-2 mt-[4px] text-lg"><FiArrowRight/></span></button></a>
      </div>
      <div className="w-1/3 md:w-full md:mt-10">
        <img src = {Cac} className="rounded-lg object-cover w-full h-56 hover:scale-105 ease-in-out duration-300" alt="Congressional App Challenge"></img>
        <h2 className="text-xl font-semibold md:text-xl mt-6">Congressional App Challenge Win</h2>
        <h3 className="text-[#929292] mt-2">BerriBasket won first-place resulting in the opportunity to demonstrate BerriBasket to members of Congress at #HouseofCode in Washington D.C. (April 2023)</h3>
        <div className="flex">
        <a href="https://www.congressionalappchallenge.us/22-CA17/"><button className="text-[#088C61]  mt-6 flex">View more<span className="ml-2 mt-[4px] text-lg"><FiArrowRight/></span></button></a>
        <Link to="/news/article?HouseOfCodeBerriBasketArticle" state={{ 
          title: "BerriBasket's trip to DC Attending House of Code at the US Capital",
          publishedDate: "23 April 2023",
          coverImg: "https://cdn.discordapp.com/attachments/1077026550723133480/1099824481649827882/52832518588_c5bfb0d3ce_o.jpg",
          coverDesc: "*BerriBasket team (Minook, Kevin, Rowan, & Livia)",
          intro: "Two years ago an amazing team of ambitious students took on a journey that would lead them to an adventure of a lifetime: building a startup. It was an ambitious journey full of trials and tribulations which eventually led them to– two years later a spectacular trip to DC to where the team was able to meet in person for the very first time. After a CAC win, BerriBasket would show their product to the people of the nation and finally have a reason to see each other... Here are some of their experiences, and what they had to say.",
          subHeading1: "Coach Juan's reflection",
          text1: "Being a sub coach of this team for over 8 months has been wonderful for me. Seeing the camaraderie and friendship grow over the past couple of months has truly been a beautiful thing, which I will forever appreciate. What I loved even more however was the chance to finally meet such talented people in a little dinner in DC. Its hard to know if we'll ever see each other again– only time will tell, but as far as my experience goes, meeting them was well worth it!",
          img2: "https://media.discordapp.net/attachments/1077026550723133480/1099844342249693255/52832530773_cde8f9d49c_o.jpg?width=1862&height=1242",
          img2Desc: "*2023 CAC winners, BerriBasket team middle right end",
          subHeading2: "Minook's reflection",
          text2: "Visiting Washington DC and meeting my team for the first time was not only fun and interesting, but also tiring. My family left for DC two days before the House Of Code event was supposed to start, so we had a day to go sightseeing, and it was nice to see the capitol and its attractions, like the monuments. I took a picture of Lincoln’s beard and of my brother holding up the Washington monument using the power of perspective, but since I have no stamina my legs hurt from walking around. On the first day of the event, I walked around and talked to the people who set up their booths to talk about their companies, and watched the panel presentations where guest speakers came in to talk about topics like AI and cybersecurity. The presentations were interesting, and after that I went with my group to go eat dinner. While I, along with Kevin and Rowan, were waiting outside a restaurant for the other group members, we saw a car getting robbed. Some person walked up to it and smashed in the back window with something like a brick and reached inside, but I couldn’t see if they took anything. The next day I arrived at the event location a little after the eastern states’ participants started presenting, and walked around listening to their presentations, asked some questions, and got the stamps for my “passport”. After this, us western state participants went and listened to congress members give speeches, which we enjoyed, and had lunch. When it was time for us to present, we set up our table and decided our roles. One of our group members would go out to speak with others, while the rest of us would cycle through and take turns presenting to anyone who came to listen. As the event went on for a while, my throat started getting really dry from talking too much, and I wanted to get more water (since I ran out) but it turned out that all the entrances were blocked by the police because of a bomb threat, and we could leave but not reenter. After the presentation, all of us teammates went our own ways and my family ate dinner.",
          subHeading3: "Kevin's reflection",
          text3: "This trip to Washington DC was my first time on the east coast and also the first time meeting some of my team members which were both amazing experiences. On the first day, I visited all the famous landmarks in DC with my family and although my feet were aching by the end of the day, it was well worth it. The next two days I mostly spent with the team as the House of Code event had taken place. The event went very smoothly and we got lots of good feedback from people who stopped by our booth which we will use to further improve BerriBasket. On the last day of the event, my family and I also traveled to New York before heading home which was another crazy experience in and of itself. Overall, I think the trip was a huge success as we learned many new things, but more importantly, had lots of fun.",
          subHeading4: "Rowan's reflection",
          text4: "Going to DC to finally visit my team that I have been working with for the last two years has been an unforgettable experience. Arriving on Friday to visit GW university in DC, I began to get more nervous and nervous as the time to meet the team was getting closer. But as I walked through the security of the capitol building both Livia and Kevin were waiting to finally meet me. Catching up and getting to know each other was difficult at first but by the last day conversations seemed to just flow with each other. Listening to the speakers that House of Code presente to us was amazing and inspirational. But finally being able to talk to so many people about BerriBasket and show off what we have been working on for so long was astonishing.",
          img3: "https://media.discordapp.net/attachments/1077026550723133480/1098053279889506385/IMG_9927.jpg?width=932&height=1242",
          img3Desc: "*Rowan speaking with White House White House Tech Leadership",
          img4: "https://media.discordapp.net/attachments/1077026550723133480/1098100153937821716/71a76db8-c8e0-4644-a64e-6f7ca1751d8c.jpg?width=932&height=1242",
          img4Desc: "*Livia speaking with the director of CAC",
          }}>
          <button className="text-[#088C61] mt-6 flex ml-8">House of code trip<span className="ml-2 mt-[4px] text-lg"><FiArrowRight/></span></button></Link>
          </div>
      </div>
    </div>

  </div>
      </Fade>

      <div className="ml-36 mr-36 md:ml-4 md:mr-4 flex justify-center mt-36 mb-48 md:mb-32 md:mt-28">
        <div className=" p-20 rounded-lg w-full bg-[#144444] md:p-10">
          <p className="text-2xl text-[#ffffff]" id="title">Interested in joining our beta or have questions?</p>
          <Link to={'/contact'}><button className="text-white bg-[#088C61] rounded-lg p-3 mt-6 flex items-center">Contact us<span className="ml-2 text-lg"><FiArrowRight/></span></button></Link>
        </div>
      </div>


        <div className="mt-40">
          <Fade>
          <Footer/>
          </Fade>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LandingPage)
);